
class BlogSearch {
  constructor() {
    this.initBlogSearch.bind(this);
    this.initBlogSearch();
  }

  initBlogSearch = () => {
    this.loadObject();
  }

  loadObject = () => {
    const blogSearchInput = document.querySelector(".blog__search .blog-search-field .input-group--field");
    const blogSearchResults = document.querySelector(".blog__search-results");
    const blogSearchResultsList = document.querySelector(".blog__search-results-list");
    const blogArticles = document.querySelector(".blog__articles");
  
    let timer, previousValue;
  
    if (!blogSearchInput) return;
    let searchStringPrefix = "";
  
    if (window.current.template && window.current.template.suffix != 'all') {
      searchStringPrefix += 'tag:';
      searchStringPrefix += window.location.pathname.split('/').pop();
      searchStringPrefix += ' ';
    }
  
    const searchArticle = (e) => {
      if (e.target.value && e.target.value != '' && e.target.value.length >= 3) {
        if (e.target.value != previousValue) {
          previousValue = e.target.value;
          blogSearchResults.classList.remove('hidden')
          blogSearchResults.classList.add('loading');
  
          blogSearchResultsList.innerHTML = '';
          let searchQuery = e.target.value;
  
          blogArticles.classList.add('hidden');
  
          if (timer) {
            window.clearTimeout(timer);
          }
  
          fetch("/search?q=" + encodeURIComponent(searchQuery) + "&type=article&view=article-grid-items")
          .then(response => response.text())
          .then(data => showResults(data))
          .catch((e) => {
            console.error(e);
          }); 
        }
      }
      else {
        blogSearchResults.classList.remove("loading");
        blogSearchResults.classList.add("hidden");
        blogArticles.classList.remove("hidden");
      }
    }
    blogSearchInput.addEventListener("input", searchArticle);
  
    const showResults = (data) => {
      if (data) {
        blogSearchResultsList.innerHTML = data;
      }
      else {
        blogSearchResultsList.innerHTML = "No results found";
        updateHistoryState();
      }
      timer = window.setTimeout(function () {
        blogSearchResults.classList.remove('loading');
      }, 1500);
    }
  }
}